import { MdPeople } from "react-icons/md";
import { StatsCard } from "../../../layouts/StatsCard";
import { useNavigate } from "react-router-dom";

export const SuperAdminDashboard = () => {
    const navigate = useNavigate()
    return (
        <div className="p-6 space-y-6">
            {/* Header */}
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">Dashboard</h2>
                <button onClick={()=>navigate('/register')} className="bg-primary-500 font-semibold text-white px-4 py-2 rounded-lg">
                    Create Admin
                </button>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <StatsCard
                    count="04"
                    title="Active Users"
                    bg="bg-blue-50"
                    icon={<MdPeople className="text-blue-600 text-3xl" />}
                    onClick={() => navigate('/app/department')}
                />
            </div>
        </div>
    );
};
